import axios from "axios";

const env = require('../.config');

export default (route) => {
    return axios.get(`${env.content.host}${route}/?populate=%2A`, {
        headers: {
            Authorization:
                'Bearer ' + env.content.token,
        },
    }).then((response) => response.data.data);
}
